// @flow
import * as React from 'react';
import {
  Button,
  ButtonGroup,
  Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { TableSettingsContext } from '../with-table-settings';
import { ModalCloseButton } from '@coverright/ui/shared';
import { TextInput } from '@coverright/ui/inputs';
import { LoadingButton } from '@mui/lab';

export const TableSettingsSaveButton = () => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const {saveSettings} = useContext(TableSettingsContext);
  const [nameDialogOpen, setNameDialogOpen] = useState(false);

  const handleSaveClick = (filters?: boolean) => {
    saveSettings()
  }

  const handleSaveAsClick = () => {
    setNameDialogOpen(true)
  }

  const handleNameDialogClose = (name?: string) => {
    setNameDialogOpen(false)
    name && saveSettings(name)
  }

  return (
    <>
      <ViewNameDialog open={nameDialogOpen} onClose={handleNameDialogClose} />
      <ButtonGroup size={'small'}
                   ref={anchorRef}>
        <Button variant="contained" onClick={() => handleSaveClick()}>Save view</Button>
        <Button variant={'outlined'} onClick={() => handleSaveAsClick()}>Save as...</Button>
      </ButtonGroup>
    </>

  );
};

const ViewNameDialog = ({open, onClose}: {open: boolean, onClose: (value?: string) => void}) => {
  const [value, setValue] = useState('');

  useEffect(() => {open && setValue('')}, [open])

  return <Dialog fullWidth maxWidth={'xs'} open={open} onClose={() => onClose()}>
    <DialogTitle variant={'h3'}>
      Enter view name
      <ModalCloseButton onClick={() => onClose()} sx={{position: 'absolute', top: 4, right: 8}} />
    </DialogTitle>
    <DialogContent>
      <TextInput value={value} onChange={event => setValue(event.target.value as string)} hideTick />
    </DialogContent>

    <DialogActions>
      <Button
        onClick={() => onClose()}
        variant={'outlined'}
      >
        Cancel
      </Button>
      <LoadingButton
        disabled={!value}
        onClick={() => onClose(value)}
        variant={'contained'}
      >
        Save
      </LoadingButton>
    </DialogActions>
  </Dialog>
}
